<template>
  <div class="blog-page">
    <section class="blog-hero">
      <div>
        <div class="blog-tag">MobiFIX PRO BLOG</div>
        <h1>Блог про ремонт телефонів у Харкові</h1>
        <p>
          Публікуємо матеріали під популярні та довгохвості запити: ремонт iPhone після води, заміна скла iPhone 14,
          вибір акумулятора для Samsung, проблеми із зарядкою та локальні запити по Харкову.
        </p>
      </div>

      <div class="blog-cta">
        <router-link to="/orders/create" class="blog-btn blog-btn-primary">Замовити ремонт</router-link>
        <router-link to="/services/terminovyi-remont-telefoniv-kharkiv" class="blog-btn blog-btn-secondary">Терміновий ремонт</router-link>
      </div>
    </section>

    <section class="blog-grid">
      <article v-for="article in articles" :key="article.slug" class="blog-card">
        <div class="blog-date">{{ article.datePublished }}</div>
        <h2>{{ article.h1 }}</h2>
        <p>{{ article.excerpt }}</p>
        <div class="blog-keywords">
          <span v-for="keyword in article.keywords.slice(0, 2)" :key="keyword" class="keyword-chip">{{ keyword }}</span>
        </div>
        <router-link :to="article.path" class="blog-link">Читати статтю</router-link>
      </article>
    </section>

    <section class="blog-services">
      <div class="blog-services-head">
        <h2>Повʼязані сторінки послуг</h2>
      </div>

      <div class="blog-services-grid">
        <router-link
          v-for="landing in featuredLandings"
          :key="landing.slug"
          :to="landing.path"
          class="service-link-card"
        >
          <strong>{{ landing.h1 }}</strong>
          <span>{{ landing.description }}</span>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { blogArticles } from '../data/blogArticles';
import { serviceLandingList } from '../data/serviceLandings';
import { applySeo, localBusinessJsonLd } from '../utils/seo';
import { breadcrumbJsonLd } from '../utils/schema';

export default {
  name: 'BlogPage',
  setup() {
    onMounted(() => {
      applySeo({
        title: 'Блог про ремонт телефонів у Харкові',
        description: 'Корисні статті MobiFIX PRO про ремонт iPhone, Samsung, Xiaomi, заміну батареї, екрана та відновлення після води.',
        keywords: [
          'блог ремонт телефонів Харків',
          'що робити якщо iPhone впав у воду',
          'скільки коштує заміна скла iPhone 14',
          'як вибрати акумулятор для Samsung'
        ],
        path: '/blog',
        jsonLd: [
          localBusinessJsonLd(),
          breadcrumbJsonLd([
            { name: 'Головна', path: '/' },
            { name: 'Блог', path: '/blog' }
          ])
        ]
      });
    });

    return {
      articles: blogArticles,
      featuredLandings: serviceLandingList.slice(0, 6)
    };
  }
};
</script>

<style scoped>
.blog-page {
  display: grid;
  gap: 20px;
}

.blog-hero,
.blog-card,
.blog-services {
  background: #fff;
  border: 1px solid #dde4ff;
  border-radius: 22px;
  box-shadow: 0 10px 28px rgba(46, 44, 97, 0.06);
}

.blog-hero {
  padding: 28px;
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  gap: 20px;
  align-items: center;
}

.blog-tag {
  display: inline-block;
  margin-bottom: 12px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #edf2ff;
  color: #334cb5;
  font-size: 12px;
  font-weight: 800;
}

.blog-hero h1 {
  margin: 0 0 12px;
  color: #202868;
  font-size: 36px;
  line-height: 1.1;
}

.blog-hero p {
  margin: 0;
  color: #55607a;
  line-height: 1.75;
}

.blog-cta {
  display: grid;
  gap: 12px;
}

.blog-btn {
  min-height: 50px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 15px;
  font-weight: 800;
}

.blog-btn-primary {
  background: linear-gradient(135deg, #534ab7, #7f77dd);
  color: #fff;
}

.blog-btn-secondary {
  background: #edf5ff;
  color: #245bca;
}

.blog-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.blog-card {
  padding: 22px;
  min-width: 0;
}

.blog-date {
  margin-bottom: 10px;
  color: #6e78a2;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.blog-card h2 {
  margin: 0 0 10px;
  color: #202868;
  font-size: 24px;
  line-height: 1.2;
}

.blog-card p {
  margin: 0 0 14px;
  color: #55607a;
  line-height: 1.7;
  overflow-wrap: anywhere;
}

.blog-keywords {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.keyword-chip {
  padding: 6px 10px;
  border-radius: 999px;
  background: #f4f7ff;
  color: #425181;
  font-size: 12px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.blog-link {
  color: #534ab7;
  font-weight: 800;
  text-decoration: none;
}

.blog-services {
  padding: 24px;
}

.blog-services-head h2 {
  margin: 0 0 16px;
  color: #202868;
  font-size: 28px;
}

.blog-services-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.service-link-card {
  display: block;
  padding: 16px;
  border-radius: 16px;
  background: #f7f8ff;
  border: 1px solid #e1e6ff;
  text-decoration: none;
  min-width: 0;
}

.service-link-card strong {
  display: block;
  margin-bottom: 8px;
  color: #202868;
  font-size: 16px;
}

.service-link-card span {
  color: #55607a;
  font-size: 14px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

@media (max-width: 960px) {
  .blog-hero,
  .blog-grid,
  .blog-services-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .blog-hero {
    padding: 22px;
  }

  .blog-card,
  .blog-services {
    padding: 20px;
  }

  .blog-hero h1 {
    font-size: 30px;
  }
}
</style>
